
const Footer = () => {
  return (
    <div className='p-3 text-center bg-dark text-white'>
           <p>@2023 code with Prem</p>
    </div>
  )
}

export default Footer